import { useEffect } from "react";
import useTotp from "../Service/hooks/useTOTP";
import TOTPSetup from "./TOTPSetup";
import useAuthentication from "../Service/hooks/useAuthentication";
export default function SecondFactorForm({ setupRequired }) {

    const { error,checkTotpCode,checkRememberedTOTP, tokenEmailSend, sendTokenEmail } = useTotp();
    const { communicationMethod } = useAuthentication();

    useEffect(() => {
        checkRememberedTOTP();        
    }, [])

    const submitSecondFactor = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        checkTotpCode({ code: data.get('code'), remember: data.get('remember') == "on" });
    }
    
    useEffect(() => {
        if(communicationMethod === 'email' && !setupRequired) {
            sendTokenEmail();
        }
    }, [communicationMethod])

    if(setupRequired) {
        return <TOTPSetup />
    }




    return <form onSubmit={submitSecondFactor} className="flex flex-col gap-3">

        { error && <div className="bg-red-500 text-white p-2"> {error} </div> }


        <label>
            <p className="text-lg">2FA Code:</p>
            <input name="code" autoComplete="off" className="w-full border border-gray-300 p-2" />
        </label>
        <label className="flex flex-row gap-2">
            <input name="remember" type="checkbox" />
            <p className="text-lg">
                Onthoud dit apparaat/netwerk
            </p>
        </label>
        <button type="submit" className="w-full bg-[#3A194A] text-white p-2 font-bold">Inloggen afronden</button>
    </form>

}